import React from 'react';
import Browser from '../../Browser';

class BrowserWarning extends React.Component {
    render() {
        if (Browser.IsIE()) {
            window.document.body.classList.add('browser-warning')
            return (
                <div className="browser-warning-container">
                    <div className="message-warning">
                        <svg viewBox="0 0 15 15" width="15" height="15">
                            <g transform="matrix(0.18644068,0,0,0.18644068,-1.4135078,-1.9656032)">
                                <path
                                    d="M 48,15.5 C 30,15.5 15.5,30 15.5,48 15.5,66 30,80.5 48,80.5 66,80.5 80.5,66 80.5,48 80.5,30 66,15.5 48,15.5 Z m 0,5.4 C 62.9,20.9 75.1,33 75.1,48 75.1,62.9 63,75.1 48,75.1 33,75.1 20.9,62.9 20.9,48 20.9,33.1 33.1,20.9 48,20.9 Z m 0,9.9 c -2.2,0 -3.9,1.7 -3.9,3.9 0,2.2 1.7,3.9 3.9,3.9 2.2,0 3.9,-1.7 3.9,-3.9 0,-2.1 -1.7,-3.9 -3.9,-3.9 z m -3.1,10 V 65.3 H 51 V 40.8 Z"
                                    style={{fill: '#fff'}}></path>
                            </g>
                        </svg>
                        <span>{__('Sorry, your browser is not supported. Please use Google Chrome or Mozilla Firefox.')}</span>
                    </div>
                </div>
            )
        }

        return (
            <React.Fragment/>
        )
    }
}

window.components.BrowserWarning = BrowserWarning;